function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import find from 'lodash/find';
import get from 'lodash/get';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as actions from '../actions';
import Country from '../partials/Country';
var _React_PureComponent;
class ChooseCountry extends (_React_PureComponent = React.PureComponent) {
    onSetCountry(input) {
        this.setState({
            formValues: {
                values: {
                    [input.id]: input.value
                }
            }
        });
    }
    onChooseCountry() {
        this.setState({
            isInProgress: true
        });
        const alpha2Code = get(this.state.formValues, 'values.alpha2Code');
        const country = find(this.state.countries, {
            alpha2Code
        });
        this.props.onChooseCountry(country);
    }
    get isDisabled() {
        return !get(this.state.formValues, 'values.alpha2Code');
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(Country, {
                    countries: this.state.countries,
                    formValues: this.state.formValues,
                    onSetFormValue: (input)=>this.onSetCountry(input)
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mt-8",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: App.messages.buttons.continue,
                        className: "btn--block btn--filled",
                        isDisabled: this.isDisabled,
                        isInProgress: this.state.isInProgress,
                        onClick: ()=>this.onChooseCountry()
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            countries: props.countries,
            formValues: {},
            isInProgress: false
        };
    }
}
_define_property(ChooseCountry, "propTypes", {
    // Explicit props
    countries: PropTypes.arrayOf(App.shapes.country),
    // Explicit actions
    onChooseCountry: PropTypes.func
});
// const mapStateToProps = (state) => ({
// });
const mapDispatchToProps = (dispatch)=>({
        onChooseCountry: (country)=>dispatch(actions.chooseCountry(country))
    });
const ConnectedChooseCountry = connect(null, mapDispatchToProps)(ChooseCountry);
export default ConnectedChooseCountry;
